<script>
    export default {
        name: "Product option",
        props: {
            optionHead: {
                type: String,
                required: true
            },
            optionValue: {
                required: true
            },
            tipText: {
                type: String,
                default: ''
            },
            isShort: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<template>
    <div :class="['option-elem', !isShort ? 'long-elem' : '']">
        <p :class="['option-head', !isShort ? 'long-head' : '']">{{ optionHead }}</p>
        <div :class="['option-value', isShort ? 'short' : '']">
            <span v-if="isShort">{{ optionValue }}</span>
            <p v-else>{{ optionValue }}</p>
        </div>
    </div>
    <div class="hr"></div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
    .option-elem {
        display: flex;
        align-items: center;
        gap: 15px;
        width: 100%;
    }

    .option-elem.long-elem {
        align-items: flex-start;
    }

    .option-head {
        font-size: 16px;
        font-weight: 400;
        color: $black
    }

    .long-head {
        min-width: 20%;
    }

    .option-value.short {
        padding: 12px 17px;
        border-radius: 10px;
        background: $silver;
        font-size: 14px;
        font-weight: 500;
        color: $black
    }

    .option-value p {
        white-space: pre-wrap;
        line-height: 110%;
    }

    div.hr {
        border-bottom: 1px solid $gray;
        max-height: 1.5px;
        background: $gray;
    }

    @media screen and (max-width: 750px) {
        .option-head, .option-value.short, .option-value p {
            font-size: 13px;
        }

        .option-value.short {
            padding: 9px 13px;
        }

        div.hr {
            border-top: 0.5px solid $gray;
            max-height: 1px;
        }
    }
</style>
